import axios from 'axios';
import { useQuery } from 'react-query';

export default function useFindProjectIdCard(card) {
    const { data, isFetching, error } = useQuery(
        ['projectIdCards', { tagId: card?.tagId }],
        async () => {
            return (await axios.get(`/idcards/project/byProjectId/${card?.tagId}`)).data;
        },
        {
            enabled: card && card.tagId && card.isFpso,
        }
    );

    return {
        idCard: data,
        isLoading: isFetching,
        error,
    };
}
